const LanguageList = ({ languages }: { languages: string[] }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {languages.map((language) => (
        <span
          key={language}
          className="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded">
          {language.slice(0, 3).toUpperCase()}
        </span>
      ))}
    </div>
  );
}

export default LanguageList;
